import { useEffect } from 'react';
import { useRouter } from '@medifind/router';
import { getFilterValue, selectRouteParams, setShareBookmarkData, useRouteStore } from '@medifind/zustand';

export const useSearchPageBookmarkPermalink = (bookmarkName, type, data = {}, secondaryData = {}, filterList = [], dependencies = []) => {
  const router = useRouter();
  const queryParams = useRouteStore(selectRouteParams);
  // Remove numeric keys from query parameters
  const { projectId, sort, codingType } = queryParams;
  useEffect(() => {
    const modifiedQueryParams = { ...queryParams };
    Object.keys(modifiedQueryParams)
      .filter((x) => !isNaN(x))
      .forEach((x) => (modifiedQueryParams[x] = undefined));
    const filtersForRestoration = filterList
      .map((filterStore) => {
        const { name, selected, display, type } = filterStore.getState();
        let value = null;

        if (type === 'input') {
          value = selected;
        } else {
          value = Array.isArray(selected)
            ? selected
                ?.map((s) => s.display)
                ?.sort()
                ?.join(', ')
            : selected?.display;
        }

        return { name, selected, value, display };
      })
      .filter(({ value }) => value);
    const filtersForComparison = filterList
      .map((filterStore) => {
        const filter = filterStore.getState();
        const value = getFilterValue(filter);
        return { name: filter.name, value, display: filter.display };
      })
      .filter(({ value }) => value);

    setShareBookmarkData({
      bookmark: {
        data: {
          ...data,
          ...(sort ? { sort } : {}),
          filters: filtersForComparison,
        },
        ...(projectId
          ? {
              secondaryLookupId: projectId,
            }
          : {}),
        secondaryLookupData: {
          ...modifiedQueryParams,
          ...secondaryData,
          filters: filtersForRestoration,
          ...(projectId
            ? {
                type: 'projectId',
                codingType,
              }
            : {}),
        },
        bookmarkName: bookmarkName,
        type: type,
      },
      share: {
        data: {
          ...data,
          ...(sort ? { sort } : {}),
          filters: filtersForRestoration,
        },
        permaLinkURL: router.location.href,
      },
    });
  }, [router.location.href, type, bookmarkName, projectId, queryParams, ...dependencies]);
  return null;
};
